function NavIcon( {icon} ) {
  return <img src={icon} alt="Nav Icon" height={33} width={33} />;
}

export default NavIcon;
